import styles from './DropDownButton.module.css'

import React, { 
    FC, ReactNode, 
    useEffect,
    useRef
 } from 'react'
 import '../App.css'
interface Props {
    onClick?() : void,
    imgSrc: string,
    imgAlt: string
}

export const InternalButton: FC<Props> = ({
    onClick,
    imgSrc
}: Props)  => (
    <div onClick={onClick}
    >
        <img src={imgSrc} alt='imgAlt' className={styles.buttonIcon}/>
    
    </div>
)

interface PanelProps {
    children?: ReactNode

}

export const InternalDropDownPanel : FC<PanelProps> = ({
    children
} : PanelProps) => (
    <div className={styles.dropdownContent}>
        {children}
    </div>
)

interface PanelWithButtonProps {
    imgSrc: string,
    imgAlt: string,
    children?: ReactNode,

}

export const DropDownButton : FC<PanelWithButtonProps> = ({
    imgSrc,
    imgAlt,
    children
} : PanelWithButtonProps) => {
    const [open, setOpen] = React.useState(false)
    const drop = useRef<HTMLDivElement | null>(null)
    
    function handleClick (e: any) {
        if (drop.current && !e.target.closest(`.${drop.current.className}`) && open) {
            setOpen(false)
        }
    }

    useEffect(() => {
        document.addEventListener('click', handleClick)
        return () => {
            document.removeEventListener('click', handleClick)
        }
    })

    return(
        <div ref={drop} className={styles.dropdown}>
            <InternalButton imgSrc= {imgSrc} imgAlt={imgAlt} onClick={() => setOpen(open => !open)}/>
                {open &&
                    <InternalDropDownPanel>
                        {children}
                    </InternalDropDownPanel>
                }
        </div>
    )
}